import PosUsers from './PosUsers';

export default {
  title: 'POS Users',
  description:
    'Add here the details for the first persons who will start using the POS.',
  path: '/setup/pos-users',
  component: PosUsers,
  rootPath: { name: 'General Setup', uri: '/setup' },
  subPath: [{ name: 'POS Users' }],
};
